import { createRouter, createWebHistory } from "vue-router";
import Swal from "sweetalert2";


import MisCursos from "../views/student/MyCourses.vue";
import ExplorarCursos from "../views/student/Browse.vue";

import CoursePage from "../views/student/CoursePage.vue";
import LessonPage from "../views/student/LessonPage.vue";
import QuizView from "../views/student/QuizView.vue";

import TablaCursos from "../views/teacher/CourseIndex.vue";
import EditarCurso from "../views/teacher/CourseEdit.vue";
import Analytics from "../views/teacher/Analytics.vue";
import Calificaciones from "../views/teacher/Grades.vue";

import Register from "../views/auth/Register.vue";
import Login from "../views/auth/login.vue";
import RecoverPassword from "../views/auth/RecoverPassword.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";

import Categories from "../views/Users/Categories.vue";
import UserIndex from "../views/Users/UserIndex.vue";
import NewUser from "../views/Users/NewUser.vue";
import UpdateUser from "../views/Users/UpdateUser.vue";
import UpdatePassword from "../views/Users/UpdatePassword.vue";
import Overview from "../views/profile/Overview.vue";
import { getToken } from "../utilities/storage";
import Verification from "../views/student/Verification.vue";
import { getCurrentRole } from '@/utilities/roles';

const routes = [
  //Vista de Invitado

  {
    path: "/cursos/mis-cursos",
    name: "Mis Cursos",
    component: MisCursos,
    meta: { requiredRoles: [1,4] } // Owner(1), Admin(2), and Instructor(3) can access
  },

  {
    path: "/calificaciones",
    name: "Calificaciones",
    component: Calificaciones,
    meta: { requiredRoles: [1,3] } // Owner(1), Admin(2), and Instructor(3) can access
  },

  {
    path: "/",
    name: "Explorar Cursos",
    component: ExplorarCursos,
    props: true,   
  },
  {
    path: "/analiticas",
    name: "Analytics",
    component: Analytics,
    meta: { requiredRoles: [1, 2, 3] } // Owner(1), Admin(2), and Instructor(3) can access
  },
  {
    path: "/categorias",
    name: "Categories",
    component: Categories,
    meta: { requiredRoles: [1, 2] } // Owner(1), Admin(2), and Instructor(3) can access
  },
  {
    path: "/cursos/:curso",
    name: "Pagina Curso",
    component: CoursePage,
    props: true,   
  },
  {
    path: "/cursos/:curso/:capitulo/:leccion",
    name: "Pagina Leccion",
    component: LessonPage,
    props: true,   
  },
  {
    path: "/cursos/:curso/:capitulo/quiz/:quiz",
    name: "Quiz View",
    component: QuizView,
    props: true,   
    //meta: { requiredRoles: [1, 2, 4] } // Owner(1), Admin(2), and Instructor(3) can access
  },

  {
    path: "/cursos",
    name: "Tabla Cursos",
    component: TablaCursos,
    meta: { requiredRoles: [1, 2, 3] } // Owner(1), Admin(2), and Instructor(3) can access
  },  
  {
    path: '/cursos/editar/:id?',  // Ensure this path is correct
    name: 'Editar Curso',
    component: EditarCurso,
    props: true,  // Allow passing the 'id' as a prop to EditCourse
    meta: { requiredRoles: [1, 2, 3] } // Owner(1), Admin(2), and Instructor(3) can access
  },

  {
    path: "/payment/confirmation",
    name: "Verificacion",
    component: Verification
  },  

  
   //Auth
  {
    path: "/autenticacion/registro",
    name: "Register",
    component: Register,
  },
  {
    path: "/autenticacion/iniciar-sesion",
    name: "Login",
    component: Login,
  },
  {
    path: "/autenticacion/recuperar-contrasena", //Recover Pass (email)
    name: "Recover Password",
    component: RecoverPassword,
  },
  {
    path: "/autenticacion/reiniciar-contrasena/:token?", ///////////Reset PASS
    name: "Reset Password",
    component: ResetPassword,
  },

    //USUARIOS
    {
      path: "/usuarios",
      name: "Usuarios",
      component: UserIndex,
      //meta: { requiresAuth: true },
      meta: { requiredRoles: [1, 2] } // Owner(1), Admin(2), and Instructor(3) can access

    },
    {
      path: "/usuarios/nuevo-usuario",
      name: "New User",
      component: NewUser,
      //meta: { requiresAuth: true },
      meta: { requiredRoles: [1, 2] } // Owner(1), Admin(2), and Instructor(3) can access

    },
    {
      path: "/pages/users/update-user",
      name: "Update User",
      component: UpdateUser,
      //meta: { requiresAuth: true },
      meta: { requiredRoles: [1, 2] } // Owner(1), Admin(2), and Instructor(3) can access


    },
    {
      path: "/pages/users/update-password",
      name: "Update Password",
      component: UpdatePassword,
      //meta: { requiresAuth: true },
      meta: { requiredRoles: [1, 2] } // Owner(1), Admin(2), and Instructor(3) can access

    },
    {
      path: "/mi-perfil",
      name: "Mi Perfil",
      component: Overview,
      meta: { requiredRoles: [1, 2, 3, 4] } // Owner(1), Admin(2), and Instructor(3) can access
    }, 

    {
      path: "/:pathMatch(.*)*",
      redirect: "/autenticacion/iniciar-sesion", // Redirect to login or an error page
      //meta: { requiresAuth: false }, 
    }
 
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  const requiredRole = to.meta.requiredRole;
  const currentRole = getCurrentRole();
  
  if (requiredRole && currentRole > requiredRole) {
    next('/unauthorized'); // or your access denied route
  } else {
    next(); // Allow access to routes that do not require authentication
  }

  // Alerta de carga
  Swal.fire({
    title: "Cargando...",
    text: "Por favor, espera",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  // Delay para evitar error getContext de graficos
  setTimeout(() => {
    next();
  }, 800); 
});



router.afterEach(() => {
  setTimeout(() => {
    Swal.close();
  }, 500);
});

export default router;
